import React, { useState } from "react";
import { Tooltip } from "@progress/kendo-react-tooltip";

const TruncatedCell = ({ dataItem, field }) => {
  const [expanded, setExpanded] = useState(false);
  const value = dataItem[field] || "";

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <td className="cursor-default" style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
      <Tooltip content={value} position="top">
        {expanded || value.length <= 200 ? (
          value
        ) : (
          <>
            {value.substr(0, 200)}
            ...
          </>
        )}
      </Tooltip>
      {value.length > 200 && (
        <span onClick={toggleExpanded} style={{ cursor: "pointer", color: "blue", marginLeft: 5 }}>
          {expanded ? "Show Less" : "Show More"}
        </span>
      )}
    </td>
  );
};

export default TruncatedCell;
